<mat-horizontal-stepper #horizontalStepper linear="true" class="mat-elevation-z2" fxShow="false" fxShow.gt-sm>
  <!--<mat-step [stepControl]="billingForm" label="Billing address">
    <form [formGroup]="billingForm">     
      <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>First name</mat-label>
              <input matInput placeholder="First name" formControlName="firstName" required>
              <mat-error *ngIf="billingForm.controls.firstName.errors?.required">First name is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Last name</mat-label>
              <input matInput placeholder="Last name" formControlName="lastName" required>
              <mat-error *ngIf="billingForm.controls.lastName.errors?.required">Last name is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Middle Name/Initial</mat-label>
              <input matInput placeholder="Middle Name/Initial" formControlName="middleName">
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Company</mat-label>
              <input matInput placeholder="Company" formControlName="company">
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" formControlName="email" required>
              <mat-error *ngIf="billingForm.controls.email.errors?.required">Email is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Phone</mat-label>
              <input matInput placeholder="Phone" formControlName="phone" required>
              <mat-error *ngIf="billingForm.controls.phone.errors?.required">Phone is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Country</mat-label>
            <mat-select placeholder="Country" formControlName="country" required>
              <mat-option *ngFor="let country of countries" [value]="country">
                  {{country.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="billingForm.controls.country.errors?.required">Country is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>City</mat-label>
              <input matInput placeholder="City" formControlName="city" required>
              <mat-error *ngIf="billingForm.controls.city.errors?.required">City is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>State/Province</mat-label>
              <input matInput placeholder="State/Province" formControlName="state">
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Zip/Postal Code</mat-label>
              <input matInput placeholder="Zip/Postal Code" formControlName="zip" required>
              <mat-error *ngIf="billingForm.controls.zip.errors?.required">Zip/Postal Code is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Address</mat-label>
              <input matInput placeholder="Address (street, apartment, suite, unit etc.)" formControlName="address" required>
              <mat-error *ngIf="billingForm.controls.address.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
        <button mat-mini-fab matStepperNext color="primary" matTooltip="Next" matTooltipPosition="after"><mat-icon>navigate_next</mat-icon></button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="deliveryForm" label="Delivery method">
    <form [formGroup]="deliveryForm" class="p-2">
      <mat-radio-group formControlName="deliveryMethod" fxLayout="column" fxLayoutAlign="center" required name="methods">
        <mat-radio-button *ngFor="let method of deliveryMethods" color="primary" [value]="method" class="mt-1"><b>{{method.name}}</b> {{method.desc}}</mat-radio-button>
      </mat-radio-group> 
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
        <button mat-mini-fab matStepperPrevious color="primary" matTooltip="Back" matTooltipPosition="before" class="mr-1"><mat-icon>navigate_before</mat-icon></button>
        <button mat-mini-fab matStepperNext color="primary" matTooltip="Next" matTooltipPosition="after"><mat-icon>navigate_next</mat-icon></button>
      </div>
    </form>
  </mat-step> -->
  <mat-step [stepControl]="paymentForm" label="Metodo de pago">
    <form [formGroup]="paymentForm" (ngSubmit)="send()">
      
      <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput placeholder="Ingrese nombre" formControlName="name" required>
              <mat-error *ngIf="paymentForm.controls.name.errors?.required">Nombre es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Ingrese email" formControlName="email" required>
              <mat-error *ngIf="paymentForm.controls.email.errors?.required">Email es  requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Dirección</mat-label>
              <input matInput placeholder="Ingrese dirección" formControlName="address" required>
              <mat-error *ngIf="paymentForm.controls.address.errors?.required">Dirección es requerido</mat-error>
          </mat-form-field>
        </div>
        
        <div fxFlex="100" fxLayout="column" fxLayoutAlign="start start" class="p-1">
          <span class="text-muted">Credit Card</span>
          <img src="assets/images/others/card-icon.png" alt="">
        </div>        
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre de titular</mat-label>
              <input matInput placeholder="Titular de la tarjeta" formControlName="holder_name" required>
              <mat-error *ngIf="paymentForm.controls.holder_name.errors?.required">Nombre de titular es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número de tarjeta</mat-label>
              <input (keypress)="onlyNumberKey($event)" matInput placeholder="Número de la tarjeta" formControlName="card_number" required>
              <mat-error *ngIf="paymentForm.controls.card_number.errors?.required">Número de tarjeta es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Mes de expiración</mat-label>
              <mat-select placeholder="Mes de expiración" formControlName="expiration_month" required>
                <mat-option *ngFor="let month of months" [value]="month.value">
                    {{month.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="paymentForm.controls.expiration_month.errors?.required">Mes de expiración es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Año de expiración</mat-label>
              <mat-select placeholder="Año de expiración" formControlName="expiration_year" required>
                <mat-option *ngFor="let year of years" [value]="year">
                    {{year}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="paymentForm.controls.expiration_year.errors?.required">Año de expiración es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>CVV</mat-label>
              <input (keypress)="onlyNumberKey($event)" matInput placeholder="CVV" formControlName="cvv" required>
              <mat-error *ngIf="paymentForm.controls.cvv.errors?.required">CVV es requerido</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
        <button style="background: #d8a436;" type="submit"  mat-raised-button color="primary" > Suscribir </button>       
      </div>
    </form>
  </mat-step>
 
  <mat-step  label="Confirmación">

    <div  *ngIf="show" fxLayout="column" fxLayoutAlign="center center" > 
      
      <div id="Felicidades_su_suscripcin_ha_s">
        <div  *ngIf="success" >
          <span>Felicidades, su suscripción ha sido recibida con el número de confirmación</span><span style="font-style:normal;font-weight:bold;"> </span><span style="font-style:normal;font-weight:bold;color:rgba(216,164,54,1);">#{{hasplan}}.</span><br><span><br/>Recibirá un e-mail en su dirección </span><span style="font-style:normal;font-weight:bold;color:rgba(216,164,54,1);">{{email}}</span><span> con su confirmación.</span>
        </div>
  
        <div *ngIf="error" >
          <span>Lo sentimos, ha ocurrido un error con su suscripción</span>
          <br><br>
          <span style="font-style:normal;font-weight:bold;"> </span><span style="font-style:normal;font-weight:bold;color:rgba(216,164,54,1);">{{message}}.</span>
        </div>
      </div>
      
      
    </div>


    <div *ngIf="success" fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
      <img  src="assets/images/logo/Grupo 7.png"/> 
    </div>
    <div *ngIf="success" fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
      <img style="height: 150px;" src="assets/images/logo/UNIDO_LOGO.png"/>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
      <button style="background: #d8a436;" (click)="home()" mat-raised-button color="primary">Regresar al servicio</button>       
    </div>
     
  </mat-step>
</mat-horizontal-stepper>

<mat-vertical-stepper #verticalStepper linear="true" class="mat-elevation-z2" fxHide="false" fxHide.gt-sm>

  <mat-step [stepControl]="paymentForm" label="Metodo de pago">
    <form [formGroup]="paymentForm">
      
      <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput placeholder="First name" formControlName="name" required>
              <mat-error *ngIf="paymentForm.controls.name.errors?.required">Nombre es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" formControlName="email" required>
              <mat-error *ngIf="paymentForm.controls.email.errors?.required">Email es  requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Dirección</mat-label>
              <input matInput placeholder="Ingrese su dirección" formControlName="address" required>
              <mat-error *ngIf="paymentForm.controls.address.errors?.required">Dirección es requerido</mat-error>
          </mat-form-field>
        </div>
        
        <div fxFlex="100" fxLayout="column" fxLayoutAlign="start start" class="p-1">
          <span class="text-muted">Credit Card</span>
          <img src="assets/images/others/card-icon.png" alt="">
        </div>        
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre de titular</mat-label>
              <input matInput placeholder="Card holder name" formControlName="holder_name" required>
              <mat-error *ngIf="paymentForm.controls.holder_name.errors?.required">Nombre de titular es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número de tarjeta</mat-label>
              <input (keypress)="onlyNumberKey($event)" matInput placeholder="Número de tarjeta" formControlName="card_number" required>
              <mat-error *ngIf="paymentForm.controls.card_number.errors?.required">Número de tarjeta es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Mes de expiración</mat-label>
              <mat-select placeholder="Mes de expiración" formControlName="expiration_month" required>
                <mat-option *ngFor="let month of months" [value]="month.value">
                    {{month.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="paymentForm.controls.expiration_month.errors?.required">Mes de expiración es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>Año de expiración</mat-label>
              <mat-select placeholder="Mes de expiración" formControlName="expiration_year" required>
                <mat-option *ngFor="let year of years" [value]="year">
                    {{year}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="paymentForm.controls.expiration_year.errors?.required">Año de expiración es requerido</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label>CVV</mat-label>
              <input (keypress)="onlyNumberKey($event)" matInput placeholder="CVV" formControlName="cvv" required>
              <mat-error *ngIf="paymentForm.controls.cvv.errors?.required">CVV es requerido</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
        <button style="background: #d8a436;" type="submit"  mat-raised-button color="primary" > Suscribir </button>       
      </div>
    </form>
  </mat-step>

  <mat-step  label="Confirmación">



    <div  *ngIf="show" fxLayout="column" fxLayoutAlign="center center" class="p-2 text-center"> 


      <div id="Felicidades_su_suscripcin_ha_s">
        <div  *ngIf="success" >
          <span>Felicidades, su suscripción ha sido recibida con el número de confirmación</span><span style="font-style:normal;font-weight:bold;"> </span><span style="font-style:normal;font-weight:bold;color:rgba(216,164,54,1);">#{{hasplan}}.</span><br><span><br/>Recibirá un e-mail en su dirección </span><span style="font-style:normal;font-weight:bold;color:rgba(216,164,54,1);">{{email}}</span><span> con su confirmación.</span>
        </div>
  
        <div *ngIf="error" >
          <span>Lo sentimos, ha ocurrido un error con su suscripción</span> <br><br> <span style="font-style:normal;font-weight:bold;"> </span><span style="font-style:normal;font-weight:bold;color:rgba(216,164,54,1);">{{message}}.</span>
        </div>
      </div>
      
    </div>



    <div *ngIf="success" fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
      <img  src="assets/images/logo/Grupo 7.png"/> 
    </div>
    <div *ngIf="success" fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
      <img style="height: 150px;" src="assets/images/logo/UNIDO_LOGO.png"/>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-2 p-1"> 
      <button style="background: #d8a436;" (click)="home()" mat-raised-button color="primary">Regresar al servicio</button>       
    </div>
     
  </mat-step>
</mat-vertical-stepper>


  <div *ngIf="success == false && error == false" fxLayout="row wrap" class="mt-2">
    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100">
        <div fxLayout="column" fxLayoutAlign="center center" class="content">
            <button style="background: #d8a436;" (click)="showTerms()" mat-raised-button color="primary" class="mt-2">Terminos y condiciones</button>  
        </div> 
    </div>
  </div>
  
  <!-- PANEL DE TERMINOS Y CONDICIONES -->
  
  <div *ngIf="show_terms" fxLayout="row wrap" class="mt-2">
    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100">
        
        <mat-card> 
            <editor class="full-desc lh" [inline]="true" [disabled]="true" apiKey="rv7qtvpvfahwshq6y14lp4gflvg20fwiiov7gjchqtjjjmhh"
            [init]="{
              height: 500,
              menubar: false,
              plugins: [
              ],
              toolbar:
                ''
              }"
            [(ngModel)]="terms" >
        </editor>
            
        </mat-card>
  
    </div>

</div>

